module.exports = __webpack_public_path__ + "img/consultant-bg.20fe3a38.png";